import { Field, inputProps, Honeypot, Consent, isEmail, isPhone } from "./Fields";
import { useLeadForm, SubmitButton, FormError, Confirmation } from "./useLeadForm";

const initial = { name: "", company: "", email: "", phone: "", subject: "", message: "" };

function validate(v) {
  const e = {};
  if (v.name.trim().length < 2) e.name = "Indiquez votre nom.";
  if (!isEmail(v.email)) e.email = "Saisissez une adresse e-mail valide.";
  if (!isPhone(v.phone)) e.phone = "Ce numéro ne semble pas valide.";
  if (v.message.trim().length < 10) e.message = "Votre message doit contenir au moins 10 caractères.";
  return e;
}

export default function ContactForm() {
  const { values: v, errors: er, status, serverError, set, submit } = useLeadForm("/contact", initial, validate);

  if (status === "sent") {
    return (
      <Confirmation title="Message envoyé. Merci." testid="contact-confirmation">
        <p>Votre message m'a bien été transmis. Je vous réponds par e-mail dans les meilleurs délais.</p>
      </Confirmation>
    );
  }

  return (
    <form onSubmit={submit} noValidate className="relative space-y-7" data-testid="contact-form" aria-label="Formulaire de contact">
      <Honeypot value={v.hp} onChange={set} />
      <div className="grid gap-7 md:grid-cols-2">
        <Field id="name" label="Nom" error={er.name}><input {...inputProps("name", v.name, set, er.name, { autoComplete: "name" })} /></Field>
        <Field id="company" label="Entreprise" optional><input {...inputProps("company", v.company, set, null, { autoComplete: "organization" })} /></Field>
        <Field id="email" label="E-mail" error={er.email}><input type="email" {...inputProps("email", v.email, set, er.email, { autoComplete: "email" })} /></Field>
        <Field id="phone" label="Téléphone" optional error={er.phone}><input type="tel" {...inputProps("phone", v.phone, set, er.phone, { autoComplete: "tel" })} /></Field>
      </div>
      <Field id="subject" label="Objet" optional><input {...inputProps("subject", v.subject, set, null)} /></Field>
      <Field id="message" label="Message" error={er.message}><textarea rows={5} {...inputProps("message", v.message, set, er.message)} className="field resize-y" /></Field>
      <Consent checked={v.consent} onChange={set} error={er.consent} />
      <FormError message={serverError} />
      <SubmitButton status={status} testid="contact-submit">Envoyer mon message</SubmitButton>
    </form>
  );
}
